// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"c5b81ea1","185":"c5b81ea1","568":"c5b81ea1","596":"c5b81ea1","787":"c1d9f980","822":"b4ba3976","867":"c5b81ea1"}[chunkId] + ".chunk.css";
};